import styled from "styled-components";
import { LoadingSpinner } from "./LoadingSpinner";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spacing.x4}px;
  gap: ${spacing.x2}px;
  min-height: 400px;
`;

const LoadingText = styled.div`
  color: ${colors.textMuted};
  font-size: ${fontSizes.regular}px;
`;

type LoadingContainerProps = {
  message?: string;
};

export const LoadingContainer = ({ message }: LoadingContainerProps) => {
  return (
    <Container>
      <LoadingSpinner />
      {message && <LoadingText>{message}</LoadingText>}
    </Container>
  );
};

